<template>
<!-- <div class="tables-info flex justify-between"> -->
  <div class="tables-info">
    <div class="tables-number">
      <div class="label" v-if="is_reservation">Reservation</div>
      <div class="label" v-if="is_show_table_label">{{ $t("translate.table_number") }}</div>
      <div class="number">{{ tablesInfo.title }}</div>
    </div>
    <div :class="{'store-delivery':is_delivery, 'store-promo':!is_delivery}">
      <div>{{ tablesInfo.promo }}</div>
    </div>
    <div class="call-attendant" v-if="is_weixin && is_takeaway==false && is_delivery==false">
      <div class="bg-main" @click="callphone">{{ $t("translate.call_attendant") }}</div>
    </div>
  </div>
</template>
<script>
import { callAttendant } from '@/api/api'
import { cartMixin } from '@/mixins/cartMixin'

export default {
  props: {
    tablesInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      requested: false,
      is_weixin: false,
      is_takeaway: false,
      is_delivery: false,
      is_reservation: false,
      is_show_table_label: true
    }
  },
  components: {
  },
  mixins: [cartMixin],
  created () {
    this.is_weixin = this.isOnWeixin()
    this.is_takeaway = this.tablesInfo.table.is_takeaway    
    this.is_delivery = this.tablesInfo.table.is_delivery
    this.is_reservation = this.tablesInfo.table.is_reservation
    this.is_show_table_label = this.tablesInfo.table.is_show_table_label   
  },
  methods: {
    getRouteQuery () {
      let tempParams = this.$route.query
      if (tempParams.h5api == undefined) {
        tempParams["h5api"] = 'on'
      }
      // tempParams["do"] = 'SendOperatorNotice'
      return tempParams
    },
    callphone () {
      let tempParams = this.getRouteQuery()
      tempParams["do"] = 'SendOperatorNotice'
      if (this.tablesInfo.tel) {
        const queryParams = tempParams
        callAttendant('/app/index.php', queryParams).then(res => {
          this.$toast(res.msg)
        }).catch((error) => {
          this.$toast(error.msg)
        })
        // window.location.href = "tel:"+this.tablesInfo.tel
      } else {
        this.$toast("The Store tel phone doesn't exist")
      }
    }
  }
}
</script>
<style lang="less">
@import url('../../assets/css/common.less');
.tables-info {
  font-family: Arial;
  display: flex;
  align-items: center;
  font-size: @size12;
  padding: 15px 8px;
  align-items: stretch;
  background-color: @white8;
  @media screen and (max-width:950px){
    padding: 6px;
  }
  .tables-number {
    // flex-basis: 150px;
    margin-left: 10px;
    text-align: left;
    font-weight: bold;
    text-align: center;
    @media screen and (max-width:950px){
      margin-left: 0;
    }
    .label {
      margin: 0px 0;
      white-space: nowrap;
    }
    .number {
      color: @main;
      font-size: 20px;
    }
  }
  .store-promo {
    display: flex;
    align-items: center;
    font-size: @size12;
    text-align: left;
    font-weight: bold;
    padding: 0 8px;
    border-left: 1px solid @white9;
    margin-left: 8px;
  }
  .store-delivery {
    margin-left: 20px;
    display: flex;
    align-items: center;
    font-size: @size12;
    text-align: left;
    font-weight: bold;
    padding: 0 8px;
    @media screen and (max-width:950px){
      margin-left: 10px;
    }
  }
  .call-attendant {
    font-size: @size12;
    div {
      padding: 5px 5px;
      white-space: nowrap;
      border-radius: 2px;
      position: relative;
      top: 25%;
    }
  }
}
</style>